function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Hanger Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M8.48992008,7.46069873e-14 C9.70236234,7.46069873e-14 10.6849201,0.982157349 10.6849201,2.195 C10.6849201,3.23506718 9.96126214,4.10570963 8.98992008,4.33183992 L8.989,5.051 L16.4789266,10.3277208 C17.4719085,11.0281575 16.9763294,12.5893 15.7607201,12.5893 L1.24772008,12.5893 C0.0330531098,12.5893 -0.463094358,11.0305644 0.529006753,10.3290787 L7.989,5.053 L7.98992008,3.889 C7.98992008,3.61285763 8.21377771,3.389 8.48992008,3.389 C9.15005979,3.389 9.68492008,2.85457562 9.68492008,2.195 C9.68492008,1.53453336 9.15016881,1 8.48992008,1 C7.82967135,1 7.29492008,1.53453336 7.29492008,2.195 C7.29492008,2.47114237 7.07106246,2.695 6.79492008,2.695 C6.51877771,2.695 6.29492008,2.47114237 6.29492008,2.195 C6.29492008,0.982157349 7.27747782,7.46069873e-14 8.48992008,7.46069873e-14 Z M8.49029057,5.92330948 L1.1063854,11.1455552 C0.910814719,11.2838375 1.0080438,11.5893 1.24772008,11.5893 L15.7607201,11.5893 C16.0006158,11.5893 16.0979361,11.2827278 15.9027683,11.1450588 L8.49029057,5.92330948 Z",
  id: "hanger-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "hanger-Icon/Global/Dresscode",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "hanger-Swatches/Midnight",
  transform: "translate(3.500000, 6.000000)"
}, /*#__PURE__*/React.createElement("use", {
  id: "hanger-Mask",
  fill: "currentcolor",
  fillRule: "nonzero",
  xlinkHref: "#hanger-path-1"
})));

var SvgHanger = function SvgHanger(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHanger, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hanger.3309890b.svg";
export { ForwardRef as ReactComponent };